import { defaultFormItemLayout, rules } from '../../../../modules/FormItems'
import { dateVal } from '../../../../modules/Utils'
import React from 'react'
import { Col, DatePicker, Form, Input, InputNumber, Row } from 'antd'
import { get } from 'lodash'

function PaymentScheduleForm (props) {
  const { line, vouchers, modalType } = props
  const { getFieldDecorator } = props.form
  const isEdit = modalType === 'edit'

  return (
    <Form>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Name">
            {getFieldDecorator('name', {
              initialValue: get(line, 'name'),
              rules: rules.input,
            })(<Input/>)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Date">
            {getFieldDecorator('date', {
              initialValue: dateVal(line, 'date'),
              rules: rules.date,
            })(<DatePicker style={{ width: '100%' }}/>)}
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Amount">
            {getFieldDecorator('amount', {
              initialValue: get(line, 'amount'),
              rules: rules.input,
            })(<InputNumber style={{ width: '100%' }}/>)}
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

PaymentScheduleForm.propTypes = {}
PaymentScheduleForm.defaultProps = {}

export default Form.create()((PaymentScheduleForm))
